  
  
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

 
Shopify.formatMoney=function(h,a){var j=/\{\{\s*(\w+)\s*\}\}/;a=(a||this.money_format);if(typeof h=="string"){h=h.replace(/[^0-9]/g,"")}h=parseInt(h);h=h.toString();switch(h.length){case 0:h="000";break;case 1:h="00"+h;break;case 2:h="0"+h;break;default:break}var d=h.substr(h.length-2);var b=h.substr(0,h.length-2);var e=",";var i=".";function c(k,l){l=(l||",");return k.replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+l)}switch(a.match(j)[1]){case"amount_no_decimals":d="";i="";break;case"amount_with_comma_separator":e=".";i=",";break;case"amount_no_decimals_with_comma_separator":e=".";d="";i="";break;default:break}var g=c(b,e)+i+d;var f=a.replace(j,g);return f};
/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        var $addButtoncontainer = $formContainer.find('.product-add');
        $addButtoncontainer.before('<div class="errors qty-error">'+ data.description +'</div>');
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  buildCart = function(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .html('<div class="section-title"><span>Uh oh! Your cart is empty...</span></div>'+
              '<div class="cart__empty-collections">'+
     '<a href="/collections/phone-cases" class="cart__empty-collection">'+
        '<img src="//www.getcasely.com/cdn/shop/files/cart-image---all-cases_240x.jpg?v=1787133360" alt="All Cases">'+
       '<div>All Cases</div>'+
      '</a>'+   
     '<a href="/collections/whats-new" class="cart__empty-collection">'+
        '<img src="//www.getcasely.com/cdn/shop/files/cart-image---new-arrivals_240x.jpg?v=1787133360" alt="New Arrivals">'+
        '<div>New Arrivals</div>'+
      '</a>'+
               '<a href="/pages/club" class="cart__empty-collection">'+
        '<img src="//www.getcasely.com/cdn/shop/files/cart-image---club_240x.jpg?v=1787133360" alt="Monthly Subscription Club">'+
        '<div>Join the Club</div>'+
      '</a>'+
    '<a href="/collections/trending-phone-cases" class="cart__empty-collection">'+
        '<img src="//www.getcasely.com/cdn/shop/files/cart-image---trending_240x.jpg?v=1787133360" alt="Trending Cases">'+
        '<div>Trending Cases</div>'+
      '</a>'+
      '</div>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $('#CartTemplate').html(),
      template = Handlebars.compile(source);
    var cpTotal = 0;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg;
      if (cartItem.image !== null) {
        prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, '_medium$1')
          .replace('http:', '');
      } else {
        prodImg =
          '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
      }

      var saleTag;

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {

          if (key == '_Charity') {
            return;
          }
          if (key == '_saleitem') {
            saleTag = 'true';
            delete cartItem.properties[key];
          }
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }

          if (key == 'shipping_interval_frequency') {
            if (cartItem.properties[key] == 1) {
              cartItem.properties[key] = 'Ships every month';
            } else {
              cartItem.properties[key] = 'Ships every ' + cartItem.properties[key] + "  Months";
            }
          }    
          if (key == 'shipping_interval_unit_type') {
            delete cartItem.properties[key];
          }
          if (key == 'subscription_id') {
            delete cartItem.properties[key];
          }
          if (key == 'charge_interval_frequency') {
            delete cartItem.properties[key];
          }
          if (key == 'charge_interval_unit_type') {
            delete cartItem.properties[key];
          }
          if (key == 'number_charges_until_expiration') {
            delete cartItem.properties[key];
          }
        });
      }
 
 
      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount =
            cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = Shopify.formatMoney(
            amount,
            settings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = Shopify.formatMoney(
            cartAmount,
            settings.moneyFormat
          );
          
        }
      }

      var special = '';var productTitle = cartItem.product_title;var glassScreen = '';var device = '';var deviceType = ''; var ring = ''; var privacy = '';
      var url = cartItem.url;
      
  var glassScreenPrivacy = '';var glassScreen2 = ''; var glassScreen3 = '';var glassScreen4 = '';var device2 = '';var device3 = '';var device4 = '';var device5 = '';var mystery = '';
      if(cartItem.product_title.indexOf("Auto renew")>0){special="club";url = "https://www.getcasely.com/pages/club";}else{if(cartItem.product_title.indexOf("Glass Screen")>=0){special="gsp"}else{if(cartItem.product_title.indexOf("Wallet")>=0){special="wallet"}else{if(cartItem.product_title.indexOf("Gift Box")>=0){special="giftbox"}else{if(cartItem.product_title.indexOf("Phone Ring")>=0){special="phonering"}else{if(cartItem.product_title.indexOf("Gift Card")>=0){special="giftcard"}else{if(cartItem.product_title.indexOf("Pack")>=0){special="sticker"}else{if(cartItem.product_title.indexOf("Phone Loop")>=0){special="loop"}else{if(cartItem.product_title.indexOf("Mystery")>=0){special="mystery"}else{special=""}}}}}}}}}if(productTitle.indexOf("The Bold Collection")>=0){productTitle=productTitle.replace("Collection","Case")}if(productTitle.indexOf("Frida Kahlo Box")>=0){productTitle=productTitle.replace("Frida Kahlo Box","Frida Case")}if(productTitle.indexOf("x Casely")>=0){productTitle=productTitle.replace("x Casely","")}if(productTitle.indexOf("Case")>=0){if(productTitle.indexOf("Black Marble Battery-Powered Charging Case")>=0){ring=cartItem.product_title.replace("Black Marble Battery-Powered Charging Case","Classic Black Marble")}else{if(productTitle.indexOf("White Marble Battery-Powered Charging Case")>=0){ring=cartItem.product_title.replace("White Marble Battery-Powered Charging Case","Classic White Marble")}else{if(productTitle.indexOf("Hot Pink Marble Battery-Powered Charging Case")>=0){ring=cartItem.product_title.replace("Hot Pink Marble Battery-Powered Charging Case","Hot Pink Marble")}else{if(productTitle.indexOf("I'm with")>=0){ring=cartItem.product_title.replace("'","").replace(" Case","")}else{ring=cartItem.product_title.replace(" Case","")}}}}if(cartItem.variant_title.indexOf("iPhone")>=0){deviceType="iPhone";if(cartItem.product_title.indexOf("Glass Screen")>=0){device=''}else{if(cartItem.variant_title.indexOf("iPhone 12 Pro Max")>=0){glassScreenPrivacy = '40138110206055';glassScreen="32906907385959";device="12 Pro Max";mystery="39482230636647"}else
      {if(cartItem.variant_title.indexOf("iPhone 12 Pro")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110238823';glassScreen="32906907320423";device="12 Pro";mystery="39482230669415"}else{if(cartItem.variant_title.indexOf("iPhone 12 Mini")>=0){glassScreen="32906905419879";device="12 Mini";mystery="39482230734951"}else{if(cartItem.variant_title.indexOf("iPhone 12")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110271591';glassScreen="32906906435687";device="12";mystery="39482230702183"}}}}if(cartItem.variant_title.indexOf("iPhone 11 Pro Max")>=0){glassScreen="29992828993639";device="11 Pro Max";mystery="39482230767719"}else{if(cartItem.variant_title.indexOf("iPhone 11 Pro")>=0){glassScreen="29992821981287";device="11 Pro";mystery="39482230800487";}else{if(cartItem.variant_title.indexOf("iPhone 11")>=0){glassScreen="29992827224167";device="11";mystery="39482230833255";}}}if(cartItem.variant_title.indexOf("iPhone SE")>=0){glassScreen="32201430433895";device="SE (2020 & 2022)";mystery="39482230866023";}if(cartItem.variant_title.indexOf("iPhone XS Max")>=0){glassScreen="12758617751655";device="XS Max";mystery="39482230898791";}if(cartItem.variant_title.indexOf("iPhone XR")>=0){glassScreen="12758614704231";device="XR";mystery="39482230931559";}if(cartItem.variant_title.indexOf("iPhone X / XS")>=0){glassScreen="265180020757";device="X / XS";mystery="39482230964327";}if(cartItem.variant_title.indexOf("iPhone 6/7/8 Plus")>=0){device="";glassScreen="";glassScreen2="34906822278";device2="6/6s Plus";glassScreen3="34906822406";device3="7 Plus";glassScreen4="52792132757";device4="8 Plus";device5="6/7/8 Plus";mystery="39482230997095";}else{if(cartItem.variant_title.indexOf("iPhone 6/7/8")>=0){device="";glassScreen="";glassScreen2="34906822214";device2="6/6s";glassScreen3="34906822342";device3="7";glassScreen4="52792054933";device4="8";device5="6/7/8";mystery="39482231029863";}else{if(cartItem.variant_title.indexOf("iPhone 13 Pro Max")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110074983';glassScreen="39464233402471";device="13 Pro Max";mystery="39482230505575";}else{if(cartItem.variant_title.indexOf("iPhone 13 Pro")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110107751';glassScreen="39464233369703";device="13 Pro";mystery="39482230538343";}else
      {if(cartItem.variant_title.indexOf("iPhone 13 Mini")>=0){glassScreen="39464234254439";device="13 Mini";mystery="39482230603879";}else{if(cartItem.variant_title.indexOf("iPhone 13")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110140519';glassScreen="39464160362599";device="13";mystery="39482230571111";}else{if(cartItem.variant_title.indexOf("iPhone 14 Pro Max")>=0){glassScreenPrivacy = '40138109943911';privacy = 'privacy';glassScreen="39884621742183";device="14 Pro Max";mystery="";}else{if(cartItem.variant_title.indexOf("iPhone 14 Pro")>=0){privacy = 'privacy';glassScreenPrivacy = '40138109976679';glassScreen="39884621676647";device="14 Pro";mystery="";}else{if(cartItem.variant_title.indexOf("iPhone 14 Plus")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110009447';glassScreen="39884622102631";device="14 Plus";mystery="";}else{if(cartItem.variant_title.indexOf("iPhone 14")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110042215';glassScreen="39884621217895";device="14";mystery="";}else{if(cartItem.variant_title.indexOf("iPhone 8 Plus")>=0){glassScreen4="52792132757";device4="8 Plus";mystery="39482230997095";}else{if(cartItem.variant_title.indexOf("iPhone 8")>=0){glassScreen4="52792054933";device4="8";mystery="39482231029863";}}if(cartItem.variant_title.indexOf("iPhone 7 Plus")>=0){glassScreen3="34906822406";device3="7 Plus";mystery="39482230997095";}else{if(cartItem.variant_title.indexOf("iPhone 7")>=0){glassScreen3="34906822342";device3="7";mystery="39482231029863";}}if(cartItem.variant_title.indexOf("iPhone 6/6s Plus")>=0){glassScreen2="34906822278";device2="6/6s Plus";mystery="39482230997095";}else{if(cartItem.variant_title.indexOf("iPhone 6/6s")>=0){glassScreen2="34906822214";device2="6/6s";mystery="39482231029863";}else{if(cartItem.variant_title.indexOf("iPhone 15 Pro Max")>=0){glassScreenPrivacy = '40182996795495';privacy = 'privacy';glassScreen="40182988275815";device="15 Pro Max";mystery="";}else{if(cartItem.variant_title.indexOf("iPhone 15 Plus")>=0){glassScreenPrivacy = '40182996697191';privacy = 'privacy';glassScreen="40182987849831";device="15 Plus";mystery="";}else{if(cartItem.variant_title.indexOf("iPhone 15 Pro")>=0){glassScreenPrivacy = '40182996664423';privacy = 'privacy';glassScreen="40182987554919";device="15 Pro";mystery="";}else{if(cartItem.variant_title.indexOf("iPhone 15")>=0){glassScreenPrivacy = '40182996598887';privacy = 'privacy';glassScreen="40182986834023";device="15";mystery="";}}}}}}}}}}}}}}}}}}else{if(cartItem.product_title.indexOf("Glass Screen")>=0){glassScreen="";device="";deviceType="";}else{if(cartItem.variant_title.indexOf("Galaxy")>=0){deviceType="Galaxy";if(cartItem.variant_title.indexOf("Galaxy S9 Plus")>=0){glassScreen="29763789357159";device="S9 Plus";mystery="39482231193703";}else{if(cartItem.variant_title.indexOf("Galaxy S9")>=0){glassScreen="29763782606951";device="S9";mystery="39482231226471";}else{if(cartItem.variant_title.indexOf("Galaxy S22 Ultra")>=0){glassScreen="";device="";mystery="";}else{if(cartItem.variant_title.indexOf("Galaxy S22 Plus")>=0){glassScreen="39626317234279";device="S22 Plus";mystery="";}else{if(cartItem.variant_title.indexOf("Galaxy S22")>=0){glassScreen="39626315399271";device="S22";mystery="";}else{if(cartItem.variant_title.indexOf("Galaxy Note 10 Plus")>=0){glassScreen="30285228965991";device="Note 10 Plus";mystery="39482231062631";}else{if(cartItem.variant_title.indexOf("Galaxy Note 10")>=0){glassScreen="30285227524199";device="Note 10";mystery="39482231095399";}else
      {if(cartItem.variant_title.indexOf("Galaxy S10 Plus")>=0){glassScreen="29763797418087";device="S10 Plus";mystery="39482231128167";}else{if(cartItem.variant_title.indexOf("Galaxy S10E")>=0){glassScreen="";device="S10E";deviceType="";mystery="39482243842151";}else{if(cartItem.variant_title.indexOf("Galaxy S10")>=0){glassScreen="29763793616999";device="S10";mystery="39482231160935";}else{if(cartItem.variant_title.indexOf("Galaxy S9 Plus")>=0){glassScreen="29763789357159";device="S9 Plus";mystery="39482231193703";}else{if(cartItem.variant_title.indexOf("Galaxy S9")>=0){glassScreen="29763782606951";device="S9";mystery="39482231226471";}else{glassScreen="";device="";deviceType="";mystery="";}}}}}}}}}}}}}else{glassScreen="";device=""}}}}else{if(cartItem.product_title.indexOf("Auto renew")>=0){deviceType="iPhone";if(cartItem.variant_title.indexOf("iPhone 12 Pro Max")>=0){glassScreen="32936388886631";device="12 Pro Max"}else{if(cartItem.variant_title.indexOf("iPhone 12 Pro")>=0){glassScreen="32936388558951";device="12 Pro"}else{if(cartItem.variant_title.indexOf("iPhone 12 Mini")>=0){glassScreen="32936388690023";device="12 Mini"}else{if(cartItem.variant_title.indexOf("iPhone 12")>=0){glassScreen="32936386560103";device="12"}}}}if(cartItem.variant_title.indexOf("iPhone 11 Pro Max")>=0){glassScreen="29992970715239";device="11 Pro Max"}else{if(cartItem.variant_title.indexOf("iPhone 11 Pro")>=0){glassScreen="29992967176295";device="11 Pro"}else{if(cartItem.variant_title.indexOf("iPhone 11")>=0){glassScreen="29992968814695";device="11"}}}if(cartItem.variant_title.indexOf("iPhone SE")>=0){glassScreen="32501839233127";device="SE (2020 & 2022)"}if(cartItem.variant_title.indexOf("iPhone XS Max")>=0){glassScreen="12867351937127";device="XS Max"}if(cartItem.variant_title.indexOf("iPhone XR")>=0){glassScreen="12867351707751";device="XR"}if(cartItem.variant_title.indexOf("iPhone X / XS")>=0){glassScreen="2379089805333";device="X / XS"}if(cartItem.variant_title.indexOf("iPhone 8 Plus")>=0){glassScreen4="2379089772565";device4="8 Plus"}else
      {if(cartItem.variant_title.indexOf("iPhone 8")>=0){glassScreen4="2379089739797";device4="8"}}if(cartItem.variant_title.indexOf("iPhone 7 Plus")>=0){glassScreen3="2379089707029";device3="7 Plus"}else{if(cartItem.variant_title.indexOf("iPhone 7")>=0){glassScreen="2379089674261";device="7"}}if(cartItem.variant_title.indexOf("iPhone 6/6s Plus")>=0){glassScreen2="2379089641493";device2="6/6s Plus"}else{if(cartItem.variant_title.indexOf("iPhone 6/6s")>=0){glassScreen2="2379089608725";device2="6/6s"}else{if(cartItem.variant_title.indexOf("iPhone 6/7/8 Plus")>=0){device="";glassScreen="";glassScreen2="2379089641493";device2="6/6s Plus";glassScreen3="2379089707029";device3="7 Plus";glassScreen4="2379089772565";device4="8 Plus";}else{if(cartItem.variant_title.indexOf("iPhone 6/7/8")>=0){device="";glassScreen="";glassScreen2="2379089608725";device2="6/6s";glassScreen3="2379089674261";device3="7";glassScreen4="2379089739797";device4="8";}else{if(cartItem.variant_title.indexOf("iPhone 13 Pro Max")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110074983';glassScreen="39472288628839";device="13 Pro Max"}else{if(cartItem.variant_title.indexOf("iPhone 13 Pro")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110107751';glassScreen="39472288694375";device="13 Pro"}else{if(cartItem.variant_title.indexOf("iPhone 13 Mini")>=0){glassScreen="39472288792679";device="13 Mini"}else{if(cartItem.variant_title.indexOf("iPhone 13")>=0){privacy = 'privacy';glassScreenPrivacy = '40138110140519';glassScreen="39472288759911";device="13"}}}}}}}}}else{deviceType="";glassScreen="";device="";ring=""}};


 var str = cartItem.product_title;
var test = str.split(" | ");

var name2 = test[test.length - 1];
var name1 = str.replace(" | "+name2,"");
      name2 = name2.replace('40.00% Off Auto renew','(Club Discount)').replace(name1,'');
      
      var varID = cartItem.variant_id; // needed to find right variant from ajax results
      var comparePrice = 0;
      var cp = 0;
      $.ajax({url:"/products/"+cartItem.handle+".js",dataType:"json",async:false,success:function(a){a.variants.forEach(function(b){if(b.id==varID&&b.compare_at_price!==null){cp=(b.compare_at_price*cartItem.quantity)-cartItem.final_line_price;comparePrice=Shopify.formatMoney((b.compare_at_price*cartItem.quantity),settings.moneyFormat).replace(/((\,00)|(\.00))$/g,"")}})}}); 
      cpTotal = cpTotal + cp;
if (comparePrice === (Shopify.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
).replace(/((\,00)|(\.00))$/g, ''))){
  
  comparePrice = '';
}
      // Create item's data object and add to 'items' array
      item = {  
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: url,
        img: prodImg,
        name: cartItem.product_title,
        name1: name1,
        name2: name2,
        ring: ring,
        variation: cartItem.variant_title,
        saleTag: saleTag,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ).replace(/((\,00)|(\.00))$/g, ''),
        discountedPrice: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ).replace(/((\,00)|(\.00))$/g, '').replace('$0','FREE'),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
        cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor,
        special: special,
        gsp: glassScreen,
        gsp2: glassScreen2,
        gsp3: glassScreen3,
        gsp4: glassScreen4,
        gspP: glassScreenPrivacy,
        gspTitle: device,
        gspTitle2: device2,
        gspTitle3: device3,
        gspTitle4: device4,
        gspTitle5: device5,
        mystery: mystery,
        deviceType: deviceType,
        comparePrice: comparePrice,
        comparePriceNum: cp,
        privacy: privacy
 
      };
  
      items.push(item);
    });

    if (cart.total_discount !== null) {
      cpTotal = cpTotal + cart.total_discount;
    }

    var BeforeTotal =  cart.total_price + cpTotal;
    var fsThreshold =  0 * 100;

    if (BeforeTotal === cart.total_price){
      BeforeTotal = '';
    }

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      subTotalPrice:Shopify.formatMoney(
        cart.items_subtotal_price,
        settings.moneyFormat
      ).replace(/((\,00)|(\.00))$/g, ''),
      totalPrice: Shopify.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ).replace(/((\,00)|(\.00))$/g, ''),
      moneyTilFreeShipping: Shopify.formatMoney(
        (fsThreshold - cart.total_price),
        settings.moneyFormat
      ),
      moneyTilFreeTwoShipping: Shopify.formatMoney(
        (10000 - cart.total_price),
        settings.moneyFormat
      ),
      FreeShippingPercentage: (cart.total_price/fsThreshold)*100,
      FreeTwoShippingPercentage: (cart.total_price/10000)*100,
      fsApplied:
      cart.total_price >= fsThreshold ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      TwofsApplied:
      cart.total_price < 10000 ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
       ShipApplied:
      cart.total_price < 8000 ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      belowMin:
      cart.total_price >= 2000  ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
        zero:
      cart.total_price = 0  ? false : true,
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      cartBeforeDiscount: Shopify.formatMoney(
        BeforeTotal,
        settings.moneyFormat
      ).replace(/((\,00)|(\.00))$/g, ''),
      compareTotal: Shopify.formatMoney(
        (BeforeTotal),
        settings.moneyFormat).replace(/((\,00)|(\.00))$/g, ''),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
      cart.cart_level_discount_applications.length === 0 ? false : true,
      cpDiscountsApplied:
      BeforeTotal.length === 0 ? false : true,
      cartTotalSavings: cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0
    };


    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
 

     if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }

  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--remove')) {
            qty = 0;
      } else{
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
    
    
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));





//get the cart
let cart = $.getJSON('/cart.js');
// wait for the response
cart.done(function(){
  //when you have the response, get the JSON and set items to cart.items
  cart = cart.responseJSON;
  let items = cart.items;
  // make a boolean to make sure that the item you want to add isnt already in the cart (to keep the JS from firing again on page reload)
  let sub_in_cart = false;
  //  let gsp_in_cart = false;

  //check the cart items and set boolean to true if the item is in the cart
  for(var i = 0; i < items.length; i++){
    if (items[i].product_id == 318572068885){
      sub_in_cart = true;
    }
    if (items[i].product_id == 2067099320423){
      sub_in_cart = true;
    }

    if (items[i].product_id == 775320600679){
      sub_in_cart = true;
    }
    if (items[i].product_id == 775319978087){
      sub_in_cart = true;
    }} 
   
  if(sub_in_cart){$(".skillbar-bar.ready").css("width","100%");$("form[action^='/cart/add'] button.club-button").css("display","block");$("form[action^='/cart/add'] button[type='submit']").css("display","none")}else{$("form[action^='/cart/add'] button.club-button").css("display","none");$("form[action^='/cart/add'] button[type='submit']").css("display","block")};
}); 